// Enhanced AxiosInstance with session management
import axios from 'axios';
import { toast } from 'react-toastify';
import apiConfig from './components/pages/apiConfig.ts';
import './utils/toastManager';

// Create axios instance with base configuration
const axiosInstance = axios.create({
  baseURL: apiConfig.apiBaseURL,
  timeout: 10000, // 10 seconds timeout
});

// Request interceptor - automatically add auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Import the main axios interceptor to handle session management
import './utils/axiosInterceptor';

// Note: The response interceptor is now handled by the global axiosInterceptor
// which provides better session management through the SessionContext

export default axiosInstance;